module.exports = __webpack_public_path__ + "media/gallery/berlin-4-min-c0e0dd53.webp";